/**
 * FIX-4 contact form copy, verbatim from UX-SPEC (prod-fixes-2026-10-02) section 13, IDs X4-1..X4-11.
 * Keyed by the deck ID so it can move into the shared copy deck unchanged. `{n}` is filled by fmtContactCopy.
 *
 * X4-12 is NOT in the deck yet: the server now caps attachments at 10 MB in total and the spec has no line for it.
 * Proposed wording, pending UX sign-off (prod-fixes-2026-10-02/tasks/T6/NOTES.md).
 */
export const CONTACT_US_COPY = {
    'X4-1': 'Please write a message.',
    'X4-2': "That email doesn't look right. Check it, or leave it blank.",
    'X4-3': 'Please tick "I\'m not a robot" first.',
    'X4-4': 'Sending…',
    'X4-5': 'Uploading attachment… {n}%',
    'X4-6': 'Thanks — your message was sent.',
    'X4-7': "We'll reply to the email you entered.",
    'X4-8': "You didn't leave an email, so we won't be able to reply.",
    'X4-9': 'Send another message',
    'X4-10': 'Your message didn\'t send. Please tick "I\'m not a robot" again and resend, or email us at support@xconvert.com.',
    'X4-11': "You've sent several messages in a short time. Please wait a few minutes and try again.",
    'X4-12': 'Attachments can be up to 10 MB in total. Choose a smaller file, or email it to us at support@xconvert.com.',
} as const;

export type ContactUsCopyId = keyof typeof CONTACT_US_COPY;

export function fmtContactCopy(id: ContactUsCopyId, params: Record<string, string | number> = {}): string {
    return CONTACT_US_COPY[id].replace(/\{(\w+)\}/g, (whole, key) => (key in params ? String(params[key]) : whole));
}
